import { render, staticRenderFns } from "./HintsFloatingButton.vue?vue&type=template&id=4a53e6ea&"
import script from "./HintsFloatingButton.vue?vue&type=script&lang=js&"
export * from "./HintsFloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports